export default {
  path: '/boleto',
  component: () => import('@/feature/installments/views/InstallmentsWrapper.vue'),
  children: [{
    path: 'nao-encontrado',
    component: () => import('@/views/NotFound.vue'),
  }, {
    path: '',
    name: 'billet',
    component: () => import('@/feature/installments/views/BilletPage.vue'),
  }],
};
